import { Box, LinkButton } from "@bca/ui-library";

const ClaimsMissingItemsLinks: React.FunctionComponent = () => {
  const flexDirection = "column";
  const alignItems = "flex-start";
  const marginLeft = 0;

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection={flexDirection}
      justifyContent="space-between"
      alignItems={alignItems}
    >
      <Box display="flex" alignItems="center" mb={6}>
        <LinkButton
          variant="tertiary"
          fontSize={18}
          shouldOpenInNewWindow={true}
          fontWeight={700}
          p={0}
          height={21}
          link={`${process.env.VIRTUAL_DOMAIN}help/missing-items/`}
          icon="flag"
          iconWeight="solid"
          iconWidth={18}
          iconHeight={18}
          data-en="click"
          data-ec="button"
          data-el="report-missing-items"
          data-ea="start"
          data-es="primary-information"
        >
          Report Missing Items
        </LinkButton>
      </Box>
      <Box ml={marginLeft} display="flex" alignItems="center">
        <LinkButton
          variant="tertiary"
          fontSize={18}
          shouldOpenInNewWindow={true}
          fontWeight={700}
          p={0}
          height={21}
          link={`${process.env.VIRTUAL_DOMAIN}help/customer-claims/`}
          icon="file-invoice"
          iconWeight="solid"
          iconWidth={18}
          iconHeight={18}
          data-en="click"
          data-ec="button"
          data-el="make-a-claim"
          data-ea="start"
          data-es="primary-information"
        >
          Make A Claim
        </LinkButton>
      </Box>
    </Box>
  );
};

export default ClaimsMissingItemsLinks;
